import React from 'react'
import NumberFormat from 'react-number-format'
import * as _ from 'lodash'
import { format } from 'date-fns'

import { createMuiTheme } from '@material-ui/core/styles'

import { germiniDefaultColors } from 'assets/jss/material-dashboard-pro-react'

export const moneyFormatValue = (value) => {
    if (value.length < 20) {
        var v = parseFloat(value)
            .toFixed(2)
            .replace('.', ',')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
        return v
    }
}
export function formatCurrency(value, redeemedValueGreaterThanZero) {
    const currencyMask = new Intl.NumberFormat(
        redeemedValueGreaterThanZero ? 'en-US' : 'pt-br',
        {
            style: 'currency',
            currency: redeemedValueGreaterThanZero ? 'USD' : 'BRL',
        },
    )
    let result = null

    if (redeemedValueGreaterThanZero) {
        result = `SD$ ${currencyMask.format(value).replace('$', '')}` ?? '-'
    } else {
        result = `R$ ${currencyMask.format(value).replace('R$', '')}` ?? '-'
    }
    return (value && result) || '-'
}

export const numberFormatText = (_data, _prefix, _toFix, _isSeed) => {
    let _toFixed = _toFix === undefined ? 0 : _toFix
    let tSeparator = '.'
    let dSeparator = ','
    //
    if (localStorage.getItem('i18nextLng') !== null) {
        if (
            localStorage.getItem('i18nextLng') === 'pt-BR' ||
            localStorage.getItem('i18nextLng') === 'es'
        ) {
            tSeparator = '.'
            dSeparator = ','
        } else {
            tSeparator = ','
            dSeparator = '.'
        }
    }
    //
    if (_isSeed) {
        tSeparator = '.'
        dSeparator = ','
    }
    //
    let v =
        _toFixed === 0 ? _.toInteger(_data) : Number(_data).toFixed(_toFixed)
    // console.log('T: ', tSeparator)
    // console.log('D: ', dSeparator);
    // console.log('V: ', v);
    // console.log('-----------------------')
    //
    return (
        <NumberFormat
            value={v}
            displayType={'text'}
            thousandSeparator={tSeparator}
            decimalSeparator={dSeparator}
            decimalScale={2}
            prefix={_prefix}
            isNumericString={true}
        />
    )
}

export const themeUtil = () => {
    return createMuiTheme({
        overrides: {
            MuiButtonBase: {
                // Name of the component ⚛️ / style sheet
                root: {
                    // Name of the rule
                    border: '1px solid green !important',
                    borderRadius: '3px',
                    padding: '0 12px 0 12px !important',
                    maxWidth: '32px !important',
                    height: '33px',
                    margin: '3px',
                    '&:hover': {
                        background: 'green !important',
                        color: 'white',
                    },
                },
            },
        },
        palette: {
            primary: {
                main: germiniDefaultColors[0],
            },
        },
        typography: {
            useNextVariants: true,
        },
    })
}

export const VerifyCPF = (cpf) => {
    let valido = true
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf === '') valido = false
    // Elimina CPFs invalidos conhecidos
    if (
        cpf.length !== 11 ||
        cpf === '00000000000' ||
        cpf === '11111111111' ||
        cpf === '22222222222' ||
        cpf === '33333333333' ||
        cpf === '44444444444' ||
        cpf === '55555555555' ||
        cpf === '66666666666' ||
        cpf === '77777777777' ||
        cpf === '88888888888' ||
        cpf === '99999999999'
    ) {
        valido = false
    }
    // Valida 1o digito
    let add = 0
    for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i)
    }
    let rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(9))) {
        valido = false
    }
    // Valida 2o digito
    add = 0
    for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i)
    }
    rev = 11 - (add % 11)
    if (rev === 10 || rev === 11) {
        rev = 0
    }
    if (rev !== parseInt(cpf.charAt(10))) {
        valido = false
    }
    //
    if (valido) {
        // console.log('O CPF INFORMADO É VÁLIDO.');
    } else {
        // console.log("o CPF é inválido");
    }
    return valido
}

const cnpjCharValue = char => {
    const c = char.toUpperCase()
    if (c >= '0' && c <= '9') return c.charCodeAt(0) - 48
    if (c >= 'A' && c <= 'Z') return c.charCodeAt(0) - 48
    return -1
}

export const VerifyCNPJ = (cnpj) => {
    cnpj = cnpj.replace(/[.\-\/\s]/g, '').toUpperCase()
    if (cnpj === '' || cnpj.length !== 14) return false

    if (/^(.)\1+$/.test(cnpj)) return false

    const calcDV = (len, offset) => {
        let soma = 0
        let pos = len - offset
        for (let i = len; i >= 1; i--) {
            soma += cnpjCharValue(cnpj.charAt(len - i)) * pos--
            if (pos < 2) pos = 9
        }
        const r = soma % 11
        return r < 2 ? 0 : 11 - r
    }

    // Aceita algoritmo tradicional (offset=7) ou novo alfanumérico (offset=6)
    const valid = (offset) =>
        calcDV(12, offset) === parseInt(cnpj.charAt(12)) &&
        calcDV(13, offset) === parseInt(cnpj.charAt(13))

    return valid(7) || valid(6)
}

export const VerifyCPFCNPJ = (document) =>
    VerifyCPF(document) || VerifyCNPJ(document)

export const FormatCPF = (cpf) => {
    return (
        cpf.substr(0, 3) +
        '.' +
        cpf.substr(3, 3) +
        '.' +
        cpf.substr(6, 3) +
        '-' +
        cpf.substr(9, 2)
    )
}

export const FormatCNPJ = (cnpj) => {
    const raw = cnpj.replace(/[.\-\/]/g, '').toUpperCase()
    return (
        raw.substr(0, 2) +
        '.' +
        raw.substr(2, 3) +
        '.' +
        raw.substr(5, 3) +
        '/' +
        raw.substr(8, 4) +
        '-' +
        raw.substr(12, 2)
    )
}

export const MaskCnpj = (cnpj) => {
    if (!cnpj) return ''
    const raw = cnpj.replace(/[.\-\/]/g, '').toUpperCase().slice(0, 14)
    const len = raw.length
    if (len <= 2) return raw
    if (len <= 5) return raw.slice(0, 2) + '.' + raw.slice(2)
    if (len <= 8) return raw.slice(0, 2) + '.' + raw.slice(2, 5) + '.' + raw.slice(5)
    if (len <= 12) return raw.slice(0, 2) + '.' + raw.slice(2, 5) + '.' + raw.slice(5, 8) + '/' + raw.slice(8)
    return raw.slice(0, 2) + '.' + raw.slice(2, 5) + '.' + raw.slice(5, 8) + '/' + raw.slice(8, 12) + '-' + raw.slice(12)
}

export const MaskCpf = (cpf) => {
    if (!cpf) return ''
    const num = cpf.replace(/[^\d]/g, '').slice(0, 11)
    const len = num.length
    if (len <= 3) return num
    if (len <= 6) return num.slice(0, 3) + '.' + num.slice(3)
    if (len <= 9) return num.slice(0, 3) + '.' + num.slice(3, 6) + '.' + num.slice(6)
    return num.slice(0, 3) + '.' + num.slice(3, 6) + '.' + num.slice(6, 9) + '-' + num.slice(9)
}

export const formatDate = (date) => {
    if (!date) return ''
    const formattedDate = format(new Date(date), 'MM-dd-yyyy')

    return formattedDate
}

export const formatCellAndTell = (tel) => {
    const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/
    var str = tel?.replace(/[^0-9]/g, '').slice(0, 11)

    const result = str?.replace(regex, '($1) $2-$3')

    return result ?? ''
}

export const formatCellHidden = (tel) => {
    const regex = /^([0-9]{2})([0-9]{4,5})([0-9]{4})$/

    const result = tel?.replace(regex, '$1-$2-$3')

    const resultNew = result?.split('-')
    return `(${resultNew[0]}) **** - ${resultNew[2] ?? ''}`
}

export const getProgramTitle = (subTitle) => {
    try {
        const programName = localStorage.getItem('programName')

        return programName && subTitle
            ? `${programName} - ${subTitle}`
            : programName || subTitle || ''
    } catch (error) {
        console.log('Error: ', error)
        return subTitle
    }
}
